var _style, _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8ReactNative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0EAED9;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,68C22.2,68,2,59.2,2,48s20.2-20,46-20s46,8.8,46,20S73.8,68,48,68z M48,32C22.8,32,6,40.2,6,48 s16.8,16,42,16s42-8.2,42-16S73.2,32,48,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2,89.2c-2,0-3.6-0.4-5.2-1.4c-9.8-5.6-7.2-27.4,5.6-49.8l0,0c6-10.4,13.4-19.2,20.6-24.8 c7.8-6,14.8-7.8,19.6-5c5,2.8,6.8,9.8,5.6,19.6c-1.2,9.2-5.2,20-11.2,30.4S51.8,77.4,44.6,83C39.4,87,34.4,89.2,30.2,89.2z  M65.8,10.8c-3.2,0-7.4,1.8-12,5.4C47,21.6,40,30,34.2,40l0,0C21.6,61.8,20.4,80.6,27,84.4c3.4,2,9,0.2,15.2-4.6 C49,74.4,56,66,61.8,56s9.6-20.2,10.8-28.8c1-8-0.2-13.6-3.6-15.6C68,11.2,67,10.8,65.8,10.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,89.2C56,89.2,41.6,77,30.8,58C17.8,35.6,15.2,13.8,25,8.2l0,0c9.8-5.6,27.4,7.4,40.4,29.8 c6,10.4,10,21.2,11.2,30.4C78,78.2,76,85,71,88C69.4,88.8,67.8,89.2,66,89.2z M27,11.6c-6.6,3.8-5.4,22.6,7.2,44.4 S62.4,88.2,69,84.4c3.4-2,4.6-7.6,3.6-15.6c-1.2-8.6-5-18.8-10.8-28.8C49.2,18.2,33.6,7.8,27,11.6L27,11.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48,
    cy: 48,
    r: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ReactNative);
export default __webpack_public_path__ + "static/media/icons8-react-native.77ec620d0afc61c80b59e9211a229a75.svg";
export { ForwardRef as ReactComponent };